import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ComfirmCreditFail" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "企业认证失败", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "失败原因：未查询到该企业的工商信息", -1)
const _hoisted_4 = { class: "CCStep__resultControls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_icon, {
      type: "close-circel",
      class: "text-error",
      size: 130
    }),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_button, {
        type: "default",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace(_ctx.gobackTo)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toRetry')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("重新认证")
        ]),
        _: 1
      })
    ])
  ]))
}